import {useDimensions} from '../../contexts/dimensions/use-dimensions'
import {FullWidthNavBar} from './components/full-width/full-width-nav-bar'
import {HamburgerNavBar} from './components/hamburger/hamburger-nav-bar'

export function Navigation(): JSX.Element {
    const {width} = useDimensions()
    return width <= 1025 ? <HamburgerNavBar /> : <FullWidthNavBar />
}
